/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const quiz = () => {
  const quizSteps = document.querySelectorAll('.js-move');
  const clearSteps = document.querySelectorAll('.js-move-clear');
  const countBtn = document.querySelector('.js-count-quiz');
  const saveBtn = document.querySelector('.js-save-quiz');

  if (!quizSteps || !clearSteps || !countBtn || !saveBtn) {
    return;
  }

  quizSteps.forEach(quizStep => {
    quizStep.addEventListener(
      'click',
      event => {
        if (quizStep !== event.target) return;
        const activePart = document.querySelector('.js-move-part.is-active')
          .dataset.step;
        const allParts = document.querySelectorAll('.js-move-part');
        const next = document.querySelector(
          `.js-move-part[data-step="${parseInt(activePart, 10) +
            parseInt(event.target.dataset.direction, 10)}"]`,
        );
        allParts.forEach(item => {
          item.classList.remove('is-active');
        });
        next.classList.add('is-active');
      },
      true,
    );
  });
  clearSteps.forEach(clearStep => {
    clearStep.addEventListener(
      'click',
      event => {
        const allParts = document.querySelectorAll('.js-move-part');
        const next = document.querySelector(`.js-move-part[data-step="1"]`);
        allParts.forEach(item => {
          item.classList.remove('is-active');
        });
        next.classList.add('is-active');
      },
      true,
    );
  });
  countBtn.addEventListener(
    'click',
    event => {
      const allValues = document.querySelectorAll(
        '.js-quiz-wrapper input:not([type="checkbox"]), .js-quiz-wrapper select',
      );
      let counter = 0;
      allValues.forEach(item => {
        let value = parseInt(item.value, 10);
        if (Number.isNaN(value)) {
          value = 0;
        }
        if (value > 10) {
          value = 10;
        }
        counter += value;
      });
      const evt = new CustomEvent('change');
      if (counter <= 8) {
        const option1 = document.querySelector(
          `input[name="company-choose"][value="nie-eksportuje"]`,
        );
        option1.checked = true;
        option1.dispatchEvent(evt);
      }
      if (counter >= 4 && counter <= 22) {
        const option2 = document.querySelector(
          `input[name="company-choose"][value="poczatkujacy"]`,
        );
        option2.checked = true;
        option2.dispatchEvent(evt);
      }
      if (counter >= 16 && counter <= 34) {
        const option3 = document.querySelector(
          `input[name="company-choose"][value="doswiadczony"]`,
        );
        option3.checked = true;
        option3.dispatchEvent(evt);
      }
    },
    true,
  );
  saveBtn.addEventListener(
    'click',
    event => {
      const allValues = document.querySelectorAll(
        'input[name="company-choose"]',
      );
      const levels = document.querySelectorAll(
        `input[name="filter_poziom-zaawansowania"]`,
      );
      levels.forEach(item => {
        // eslint-disable-next-line no-param-reassign
        item.checked = false;
      });
      allValues.forEach(item => {
        if (item.checked) {
          const filter = document.querySelector(
            `input[name="filter_poziom-zaawansowania"][value="${item.value}"]`,
          );
          filter.checked = item.checked;
        }
      });
    },
    true,
  );
};

export default quiz;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/quiz.js